<template>
  <div class="custGeneral">
    <div class="rowBox" style="margin: 0 0 10px 0;">
      <div class="rowTitle"><div class="rowReq">**</div>Customer Type</div>
      <div class="rowBox" :style="{ 'width' : 'auto', 'padding' : '0 5px 0 5px', 'border' : (custTypeRequired ? 'solid 1px red' : 'solid 1px lightgray'), 'border-radius' : '3px' }">
        <Checkbox :isDisabled="viewMode" style="margin: 8px 5px 8px 0;" title="Both" :isChecked.sync="custTypeSelection.Both" @checkBoxClicked="checkBoxClicked('Both')" />
        <Checkbox :isDisabled="viewMode" style="margin: 8px 5px 8px 5px;" title="Customer (Shipper/Consignee)" :isChecked.sync="custTypeSelection.Cust" @checkBoxClicked="checkBoxClicked('Cust')" />
        <Checkbox :isDisabled="viewMode" style="margin: 8px 0 8px 5px;" title="ArCustomer (Bill To)" :isChecked.sync="custTypeSelection.ArCust" @checkBoxClicked="checkBoxClicked('ArCust')" />
      </div>
    </div>
    <InputQuery :isDisabled="viewMode" placeholder="Customer Category" :isRequired="true" ref="cu_category" :items="data.CustCategoryData" itemKey="Customer Category" descKey="Description" :selectedObject.sync="data.selectedCustCategory" />
    <Input :isDisabled="viewMode" placeholder="Name" :isRequired="true" ref="cu_name" :inputValue.sync="data.cu_name"/>
    <div class="rowBox">
      <Input :isDisabled="viewMode" placeholder="Short Name" :isRequired="true" ref="cu_sname" :inputValue.sync="data.cu_sname" />
      <InputQuery :isDisabled="viewMode" style="margin: 0 10px 0 10px;" placeholder="Customer Status" :isRequired="true" ref="cu_status" :items="data.StatusData" itemKey="Customer Status" descKey="Description" :selectedObject.sync="data.selectedStatus" />
      <DateTime :isDisabled="viewMode" title="From" :value.sync="data.StatusValidFr"/>
    </div>
    <div class="rowBox">
      <Input :isDisabled="viewMode" placeholder="Comp Reg. No" style="margin: 0 5px 0 0;" :inputValue.sync="data.Cus_RegNo" />
      <Input :isDisabled="viewMode" placeholder="Subsidiary of" style="margin: 0 0 0 5px;" :inputValue.sync="data.Subsidiary" />
    </div>
    <Address :viewMode="viewMode" :data.sync="data" />
    <div class="rowBox">
      <Input :isDisabled="viewMode" placeholder="Phone No" style="margin: 0 5px 0 0;" :inputValue.sync="data.cu_phone" />
      <Input :isDisabled="viewMode" placeholder="Fax No" style="margin: 0 0 0 5px;" :inputValue.sync="data.cu_fax" />
    </div>
    <Input :isDisabled="viewMode" placeholder="Email" :inputValue.sync="data.cu_email" />
    <InputQuery :isDisabled="viewMode" placeholder="Customer Branch" :items="data.BrCodeData" itemKey="Branch Code" descKey="Branch Name" :selectedObject.sync="data.selectedBranch" />
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import DateTime from '@/components/DateTimePicker.vue';
import InputQuery from '@/components/InputQuery.vue';
import Dropdown from '@/components/Dropdown.vue';
import Address from '@/components/AddressForm.vue';
import Checkbox from '@/components/CheckBox.vue';

export default {
  components: {
    Input, DateTime, InputQuery, Dropdown, Address, Checkbox
  },
  props: {
    viewMode: { type: Boolean, default: false },
    data: { type: Object, default: function() { return {} } },
    custTypeSelection: {
      type: Object, default: function () {
        return {
          Both: false,
          Cust: false,
          ArCust: false,
        }
      }
    },
    custTypeRequired: { type: Boolean, default: false },
  },
  mounted() {
    this.$bus.$on('generalPageLoad', this.pageLoad);
    this.$bus.$on('customerSetFocus', this.setFocus);
  },
  methods: {
    checkBoxClicked: function (check) {
      try { 
        var custTypeCode = 0;
        Object.keys(this.custTypeSelection).forEach((g) => { this.custTypeSelection[g] = (check == g) ? true : false; if (check == g) { this.data['CustType'] = String(custTypeCode); }; custTypeCode += 1; });
      } catch (e) { console.log(e); };
    },
    updateCustSelection: function (selection) {
      try { 
        var custTypeCode = 0;
        Object.keys(this.custTypeSelection).forEach((g) => { this.custTypeSelection[g] = (selection == String(custTypeCode)) ? true : false; custTypeCode += 1; });
      } catch (e) { console.log(e); };
    },
    pageLoad: function () {
      if (this.data['CustType']) { this.updateCustSelection(this.data['CustType']); } else { this.updateCustSelection(''); }
    },
    setFocus: function (data) {
      this.custTypeRequired = (data['element'] == 'cu_type' ? true : false);
      try { this.$refs[data['element']].setFocus(); } catch (e) { this.$bus.$emit('customerPageChange', data['page']); };
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

  .rowBox {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .radioBoxTitle {
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .rowTitle {
    white-space: nowrap; 
    margin: 0 20px 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .rowReq {
    height: 100%;
    margin: 0 10px 0 0;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    color: #ff000088;
  }

</style>